export class IdentificacionCerraduraModel {
    id: number;
    id_cerradura: number;
    idTarjeta: number;
    idElemento: number;
    fecha: Date;
    medio: number;
    tipoTag: number;
    aporte: boolean;
    tarjetaMaster: boolean;
    aperturaTapa: boolean;
    noCerroTapa: boolean;
    fechaRecibido: Date;
    empresa: number;
    nsTarjeta: number;
    nsCerradura: number;
    nombreElemento: string;
    nombreCiudadano: string;
}
